export const footer = {
    brand:     "Qwiztime",
    tagline:   "Focused diagnostics. Real outcomes.",
    copyright: `© ${new Date().getFullYear()} Qwiztime. All rights reserved.`,
    links: [
        { label: "Privacy Policy", href: "/privacy" },
        { label: "Terms of Use",   href: "/terms"   },
        { label: "Contact",        href: "/contact"  },
        { label: "Request Refund", href: "/refund"   },
    ],
}
